import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'

export const modalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  // A fixed width wider than the window would push the close button off it.
  maxWidth: 'calc(100vw - 2rem)',
  background: transparentColors.whiteShade3,
  borderRadius: '0.5rem',
  border: 0,
  outline: 0,
  p: '1.5rem 2rem',
  zIndex: 6,
  /*
    A modal taller than the window used to be cut off at BOTH ends and could not
    be scrolled: it is centred with `top: 50%` and a translate, so the overflow
    goes off-screen in each direction with nothing to scroll. Short dialogs never
    hit it, which is why it survived; anything form-sized does immediately.
  */
  maxHeight: '90vh',
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: '0.25rem' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: primaryColors.orange,
    borderRadius: '0.25rem'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: primaryColors.white,
    borderRadius: '0.25rem'
  }
}

/*
  The dimming is the MUI Backdrop's own fill, which defaults to 0.5 black, so
  it is set there. A fill on the root as well would stack on top of it.
*/
export const modalBackgroundStyles = {
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  zIndex: 5,
  '& .MuiBackdrop-root': {
    backgroundColor: transparentColors.blackShade7
  }
}
